import {
  Laufzeit as BffLaufzeit,
  Produktlinienname,
  Selbstbeteiligung as BffSelbstbeteiligung,
  SparteAntrag,
  TaasSalesProductName,
  TaasTarifrisikoschluesselJHP,
  TaasTarifrisikoschluesselPH,
  TaasTarifrisikoschluesselRS,
  TaasTarifrisikoschluesselTHH,
  TaasTarifrisikoschluesselTKV,
  TaasTarifrisikoschluesselTKV_V2,
  TaasTarifrisikoschluesselURI,
  TaasTarifrisikoschluesselVHV,
  TaasTarifrisikoschluesselVHVV2,
  TaasTarifrisikoschluesselVWG,
  TaasTarifrisikoschluesselVWGV2,
  VorvertragsdatenDruck,
  Vorvertragskennzeichen as BffVorvertragskennzeichen,
  Vorvertragsnummer,
  Zahlungsart,
  Zahlweise
} from '@ps20/bff-models';
import dayjs from 'dayjs';
import {
  convertDateFormatFromShortIsoToLocalState,
  DATEFORMAT_LOCAL_STATE,
} from '@ps20-frontend/utils';
import { AnyAction } from 'redux';
import { Produktlinie } from './produktlinie';
import { Vorbelegungdaten } from './vorvertragVorbelegung';
import { App } from './ps20apps';
import { compareProductIdsIfExistingAndSpLaufnrNotExists } from './vnwechsel';
import { Produkt } from './produkt';

export enum VersicherterBereichEnum {
  KOMBI = 'Kombischutz',
  VERKEHR = 'Verkehrsrechtschutz',
}

export enum Vorvertragskennzeichen {
  ERWEITERTE_HAUSHALT_VERSICHERUNG = 'ERWEITERTE_HAUSHALT_VERSICHERUNG',
  MEIN_HAUSHALT_VERSICHERUNG = 'MEIN_HAUSHALT_VERSICHERUNG',
  RS_MIGRIERT = 'RS_MIGRIERT',
}

export function convertToVorvertragskennzeichen(
  bffVorvertragskennzeichen: BffVorvertragskennzeichen,
): Vorvertragskennzeichen {
  return {
    [BffVorvertragskennzeichen.ERWEITERTE_HAUSHALT_VERSICHERUNG]:
      Vorvertragskennzeichen.ERWEITERTE_HAUSHALT_VERSICHERUNG,
    [BffVorvertragskennzeichen.MEIN_HAUSHALT_VERSICHERUNG]:
      Vorvertragskennzeichen.MEIN_HAUSHALT_VERSICHERUNG,
    [BffVorvertragskennzeichen.RS_MIGRIERT]: Vorvertragskennzeichen.RS_MIGRIERT,
  }[bffVorvertragskennzeichen];
}

export function convertBffProduktNameToProduktName(produktName: string): Produktlinienname {
  return (Produktlinienname as Record<string, Produktlinienname>)[produktName.toUpperCase()];
}

export function convertToBffLaufzeit(vertragslaufzeitInYears: number): BffLaufzeit {
  return {
    [1]: BffLaufzeit.EIN_JAHR,
    [3]: BffLaufzeit.DREI_JAHRE,
  }[vertragslaufzeitInYears];
}

export function convertToProduktName(
  taasSalesProductName: TaasSalesProductName,
): Produktlinienname {
  return Produktlinienname[taasSalesProductName];
}

export function convertVwgTaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselVWG {
  return {
    ['FEUER']: TaasTarifrisikoschluesselVWG.FEUER,
    ['LEITUNGSWASSER']: TaasTarifrisikoschluesselVWG.LEITUNGSWASSER,
    ['ELEMENTAR']: TaasTarifrisikoschluesselVWG.ELEMENTAR,
    ['STURM']: TaasTarifrisikoschluesselVWG.STURM,
    ['GLAS_AUSSENFLAECHE']: TaasTarifrisikoschluesselVWG.GLAS_AUSSENFLAECHE,
    ['GLAS_INNENFLAECHE']: TaasTarifrisikoschluesselVWG.GLAS_INNENFLAECHE,
    ['OEL_TANK']: TaasTarifrisikoschluesselVWG.OEL_TANK,
    ['HAUSRAT_PLUS']: TaasTarifrisikoschluesselVWG.HAUSRAT_PLUS,
    ['HAUS_UND_WOHNSCHUTZBRIEF']: TaasTarifrisikoschluesselVWG.HAUS_UND_WOHNSCHUTZBRIEF,
  }[baustein];
}

export function convertVwgV2TaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselVWGV2 {
  return {
    ['FEUER']: TaasTarifrisikoschluesselVWGV2.FEUER,
    ['LEITUNGSWASSER']: TaasTarifrisikoschluesselVWGV2.LEITUNGSWASSER,
    ['ELEMENTAR']: TaasTarifrisikoschluesselVWGV2.ELEMENTAR,
    ['STURM']: TaasTarifrisikoschluesselVWGV2.STURM,
    ['GLAS_AUSSENFLAECHE']: TaasTarifrisikoschluesselVWGV2.GLAS_AUSSENFLAECHE,
    ['GLAS_INNENFLAECHE']: TaasTarifrisikoschluesselVWGV2.GLAS_INNENFLAECHE,
    ['OEL_TANK']: TaasTarifrisikoschluesselVWGV2.OEL_TANK,
    ['HAUSRAT_PLUS']: TaasTarifrisikoschluesselVWGV2.HAUSRAT_PLUS,
    ['HAUS_UND_WOHNSCHUTZBRIEF']: TaasTarifrisikoschluesselVWGV2.HAUS_UND_WOHNSCHUTZBRIEF,
  }[baustein];
}

export function convertVhVTaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselVHV {
  return {
    ['CYBER']: TaasTarifrisikoschluesselVHV.CYBER,
    ['ELEMENTAR']: TaasTarifrisikoschluesselVHV.ELEMENTAR,
    ['FAHRRAD']: TaasTarifrisikoschluesselVHV.FAHRRAD,
    ['FELS']: TaasTarifrisikoschluesselVHV.FELS,
    ['GLAS_AUSSENFLAECHE']: TaasTarifrisikoschluesselVHV.GLAS_AUSSENFLAECHE,
    ['GLAS_INNENFLAECHE']: TaasTarifrisikoschluesselVHV.GLAS_INNENFLAECHE,
    ['HAUS_UND_WOHNSCHUTZBRIEF']: TaasTarifrisikoschluesselVHV.HAUS_UND_WOHNSCHUTZBRIEF,
  }[baustein];
}

export function convertVhVV2TaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselVHVV2 {
  return {
    ['CYBER']: TaasTarifrisikoschluesselVHVV2.CYBER,
    ['ELEMENTAR']: TaasTarifrisikoschluesselVHVV2.ELEMENTAR,
    ['FAHRRAD']: TaasTarifrisikoschluesselVHVV2.FAHRRAD,
    ['FELS']: TaasTarifrisikoschluesselVHVV2.FELS,
    ['GLAS_AUSSENFLAECHE']: TaasTarifrisikoschluesselVHVV2.GLAS_AUSSENFLAECHE,
    ['GLAS_INNENFLAECHE']: TaasTarifrisikoschluesselVHVV2.GLAS_INNENFLAECHE,
    ['HAUS_UND_WOHNSCHUTZBRIEF']: TaasTarifrisikoschluesselVHVV2.HAUS_UND_WOHNSCHUTZBRIEF,
    ['FAHRRAD_KASKO']: TaasTarifrisikoschluesselVHVV2.FAHRRAD_KASKO,
    ['TRAGERISIKO']: TaasTarifrisikoschluesselVHVV2.TRAGERISIKO,
  }[baustein];
}

export function convertPhTaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselPH {
  return {
    ['NB']: TaasTarifrisikoschluesselPH.NB,
    ['OED']: TaasTarifrisikoschluesselPH.OED,
    ['OEL']: TaasTarifrisikoschluesselPH.OEL,
    ['HA']: TaasTarifrisikoschluesselPH.HA,
    ['VM']: TaasTarifrisikoschluesselPH.VM,
  }[baustein];
}

export function convertUnfTaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselURI {
  return {
    ['KINDERINDIVIDUALITAETSSCHUTZ']: TaasTarifrisikoschluesselURI.KINDERINDIVIDUALITAETSSCHUTZ,
    ['UNFALLRENTE']: TaasTarifrisikoschluesselURI.UNFALLRENTE,
    ['KRANKENHAUSTAGEGELD']: TaasTarifrisikoschluesselURI.KRANKENHAUSTAGEGELD,
    ['AKUTLEISTUNG']: TaasTarifrisikoschluesselURI.AKUTLEISTUNG,
    ['RUNDUMSERVICE']: TaasTarifrisikoschluesselURI.RUNDUMSERVICE,
  }[baustein];
}

export function convertJhpTaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselJHP {
  return {
    ['JHP']: TaasTarifrisikoschluesselJHP.JHP,
  }[baustein];
}

export function convertRsTaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselRS {
  return {
    ['BERUF']: TaasTarifrisikoschluesselRS.BERUF,
    ['PRIVAT']: TaasTarifrisikoschluesselRS.PRIVAT,
    ['STRAFRECHTSSCHUTZ']: TaasTarifrisikoschluesselRS.STRAFRECHTSSCHUTZ,
    ['VERKEHR']: TaasTarifrisikoschluesselRS.VERKEHR,
    ['VERMIETER']: TaasTarifrisikoschluesselRS.VERMIETER,
    ['WOHNEINHEIT']: TaasTarifrisikoschluesselRS.WOHNEINHEIT,
  }[baustein];
}

export function convertThhTaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselTHH {
  return {
    ['H']: TaasTarifrisikoschluesselTHH.H,
    ['P']: TaasTarifrisikoschluesselTHH.P,
  }[baustein];
}

export function convertTkvTaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselTKV {
  return {
    ['OP']: TaasTarifrisikoschluesselTKV.OP,
    ['HB']: TaasTarifrisikoschluesselTKV.HB,
  }[baustein];
}

export function convertTkvV2TaasBausteinToTarifrisikoschluessel(
  baustein: string,
): TaasTarifrisikoschluesselTKV_V2 {
  return {
    ['OP']: TaasTarifrisikoschluesselTKV_V2.OP,
    ['HB']: TaasTarifrisikoschluesselTKV_V2.HB,
    ['TW']: TaasTarifrisikoschluesselTKV_V2.TW,
  }[baustein];
}

export function convertProduktNameToTaasProduktName(
  productName: Produktlinienname,
): TaasSalesProductName {
  return TaasSalesProductName[productName];
}

export interface Vertragsoptionen {
  selbstbeteiligung: BffSelbstbeteiligung;
  zahlungsweise: Zahlweise;
  zahlungsart: Zahlungsart;
  vertragslaufzeit: number;
  ausgewaehltevertragslaufzeit: number;
  versicherungssumme?: number;
  beginnDatum: string;
  aenderungdatum: string;
  ablaufDatum?: string;
  angebotsdatum?: string;
  vorversicherungVorhanden: boolean;
  vorvertragsNummern?: FEVorvertragsnummer[];
  weitereVertraege?: FEVorvertragsnummer[];
  vorvertragGekuendigt?: boolean;
  vorvertragLinie?: string;
  vorvertragSofortschutz?: boolean;
  beibehalten?: boolean;
  vertragskennzeichen?: Vorvertragskennzeichen;
  isWeitererVertrag?: boolean;
  selectedKooperation?: string;
  kurzbezeichnung?: string;
  urbeginn?: string;
  verkaufsangebotKurzname?: string; // e.g. TM009, HH005
  vorvertragInformationen?: VorvertragInformationen;
}

export interface FEVorvertragsnummer {
  vertragsnummer: string;
  spLaufnummer: number;
  linkToSAbs?: string;
  firmenvertrag?: boolean;
  produktIds?: App[];
  isVertreterWechsel?: boolean;
  vorbelegungForBeibehaltung?: Vorbelegungdaten;
  selbstbeteiligung?: BffSelbstbeteiligung;
  verkaufsangebotKurzname?: string;
}

export function areFENummerEqual(
  nummer1: FEVorvertragsnummer,
  nummer2: FEVorvertragsnummer,
): boolean {
  return (
    nummer1.vertragsnummer === nummer2.vertragsnummer &&
    compareProductIdsIfExistingAndSpLaufnrNotExists(
      nummer1.produktIds,
      nummer2.produktIds,
      nummer1.spLaufnummer,
      nummer2.spLaufnummer,
    )
  );
}

export interface VorvertragInformationen {
  isNebengebaeudeUeber200qm?: boolean;
}

export const DEFAULT_LAUFZEIT_YEARS = 3;
export const BASIS_LAUFZEIT_YEARS = 1;

export function isValidLaufzeit(value: number | undefined | null): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

export function pickLongestVorbelegungLaufzeit(
  vorvertragsNummern: FEVorvertragsnummer[] | undefined,
): number | undefined {
  const valid = (vorvertragsNummern ?? [])
    .map(vn => vn?.vorbelegungForBeibehaltung?.laufzeit)
    .filter(isValidLaufzeit);
  return valid.length ? Math.max(...valid) : undefined;
}

export function determineLaufzeit(
  action: AnyAction,
  newState: Vertragsoptionen,
  produkt: Produkt,
  sectionState: Vertragsoptionen,
): void {
  const newProduktIndex = action.payload.index;
  const isBasis =
    produkt.produktlinien[newProduktIndex]?.produktName === Produktlinienname.BASIS;

  if (isBasis) {
    newState.vertragslaufzeit = BASIS_LAUFZEIT_YEARS;
    return;
  }

  newState.vertragslaufzeit = getEffectiveLaufzeit(sectionState.ausgewaehltevertragslaufzeit);
}

export function getEffectiveLaufzeit(userSelectedLaufzeitInState: number): number {
  return isValidLaufzeit(userSelectedLaufzeitInState)
    ? userSelectedLaufzeitInState
    : DEFAULT_LAUFZEIT_YEARS;
}

export function mapToBffVorvertragsNummer(
  vorvertragsNummern: Array<FEVorvertragsnummer>,
): Array<Vorvertragsnummer> {
  return vorvertragsNummern?.map(feNummer => {
    return {
      vorvertragsnummer: feNummer.vertragsnummer,
      spLaufnummer: feNummer.spLaufnummer,
      produktIds: feNummer.produktIds,
    };
  });
}

export function mapToBffVorvertragsdatenDruck(
  vorvertragsNummernForDruck: Array<FEVorvertragsnummer>,
): Array<VorvertragsdatenDruck> {
  return vorvertragsNummernForDruck?.map(feNummerDruck => {
    return {
      vorvertragsnummer: feNummerDruck.vertragsnummer,
      spLaufnummer: feNummerDruck.spLaufnummer,
      produktIds: feNummerDruck.produktIds,
      isVertreterWechsel: feNummerDruck.isVertreterWechsel,
    };
  });
}

export function selectedLinieOtherThanVorvertrag(
  selectedProduktlinie: Produktlinie,
  vorvertragLinie: string,
): boolean {
  return (
    !!vorvertragLinie &&
    !vorvertragLinie.toLowerCase().includes(selectedProduktlinie.produktName.toLowerCase())
  );
}

export function handleLinieFromVorvertrag(
  sparteAntrag: SparteAntrag,
  selectedProduktlinie: Produktlinie,
  vertragsoptionen: Vertragsoptionen,
): SparteAntrag {
  if (vertragsoptionen.vorvertragLinie) {
    sparteAntrag.ersatzgeschaeftLinieGewechselt = selectedLinieOtherThanVorvertrag(
      selectedProduktlinie,
      vertragsoptionen.vorvertragLinie,
    );
  }

  return sparteAntrag;
}

export function getVetragsOptionenFromVorvertrag(
  vertragsoptionen: Vertragsoptionen,
  vorbelegungsDaten: Vorbelegungdaten,
): Vertragsoptionen {
  vertragsoptionen.selbstbeteiligung = vorbelegungsDaten.selbstbeteiligung ?? vertragsoptionen.selbstbeteiligung;
  vertragsoptionen.angebotsdatum = vorbelegungsDaten.angebotsdatum;
  vertragsoptionen.beginnDatum = vorbelegungsDaten.beginnDatum
    ? convertDateFormatFromShortIsoToLocalState(vorbelegungsDaten.beginnDatum)
    : '';
  vertragsoptionen.aenderungdatum = vorbelegungsDaten.wirksamkeitsbeginn
    ? dayjs(vorbelegungsDaten.wirksamkeitsbeginn).add(1, 'd').format(DATEFORMAT_LOCAL_STATE)
    : vertragsoptionen.aenderungdatum;
  vertragsoptionen.ablaufDatum = vorbelegungsDaten.ablaufDatum
    ? convertDateFormatFromShortIsoToLocalState(vorbelegungsDaten.ablaufDatum)
    : '';
  vertragsoptionen.ausgewaehltevertragslaufzeit = vorbelegungsDaten.laufzeit;
  vertragsoptionen.vertragslaufzeit = vorbelegungsDaten.laufzeit;
  vertragsoptionen.urbeginn = vorbelegungsDaten.urbeginn;
  return vertragsoptionen;
}
